import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsAppView, setIsMinimal } from "../redux/layoutSlice";
import { updateLocalStorageFlag } from "./oauthHelpers";

const useSetupViewFlags = () => {
    const dispatch = useDispatch();
    const isMinimal = useSelector((state) => state.layout.isMinimal);
    const appview = useSelector((state) => state.layout.appview);

    // Set Redux values from URL params
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get("minimal") === "1") {
            dispatch(setIsMinimal(true));
        }

        if (params.get("utm_medium") === "app") {
            dispatch(setIsAppView(true));
        }
    }, [dispatch]);

    // Sync values to localStorage
    useEffect(() => {
        updateLocalStorageFlag("minimal", isMinimal);
    }, [isMinimal]);

    useEffect(() => {
        updateLocalStorageFlag("appview", appview);
    }, [appview]);
};

export default useSetupViewFlags;
